import React from 'react'
import { TaskT } from 'ui-io/task-io/task-t'
import { Button, HTMLSelect, Position } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { useMutation, useQueryClient } from 'react-query'
import { taskAddTagMutation } from 'ui-io/queries/tasks/task-add-tag-mutation'
import { taskRemoveTagMutation } from 'ui-io/queries/tasks/task-remove-tag-mutation'
// import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/tasks-query'
import { Box, InlineSpinnerIcon } from 'ui-components'

import toasts from '../../utils/toasts'
import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/task-query'

const FlagTask = ({ task }: { task: TaskT }) => {
  const flags = [
    'TASK_FLAG-Set flag',
    'TASK_FLAG-FOLLOW_UP',
    'TASK_FLAG-IMPORTANT',
    'TASK_FLAG-ISSUE',
  ]
  const queryClient = useQueryClient()
  const addTagMutation = useMutation(taskAddTagMutation, {
    onError: (err) => {
      toasts.error(`Unable to add flag: ${err}`)
    },
    onSuccess: () => {
      toasts.success('Flag added successfully')
      queryClient.refetchQueries([TASKS_QUERY_FILTER])
    },
  })
  const removeTagMutation = useMutation(taskRemoveTagMutation, {
    onError: (err) => {
      toasts.error(`Unable to remove flag: ${err}`)
    },
    onSuccess: () => {
      toasts.success('Flag removed successfully')
      queryClient.refetchQueries([TASKS_QUERY_FILTER])
    },
  })
  const currentFlag = task._raw.tags?.find((flag) => flag.includes('TASK_FLAG'))
  const isLoading = addTagMutation.isLoading || removeTagMutation.isLoading
  return (
    <>
      {currentFlag ? (
        <Tooltip2
          content={'Remove flag'}
          position={Position.BOTTOM}
          hoverOpenDelay={1000}
        >
          <Button
            onClick={() =>
              removeTagMutation.mutate({
                taskId: task._raw.task_id,
                flag: currentFlag,
              })
            }
            intent={'warning'}
            icon="flag"
          >
            {isLoading ? (
              <Box mx="small" inline>
                <InlineSpinnerIcon />
              </Box>
            ) : (
              currentFlag.split('-')[1]
            )}
          </Button>
        </Tooltip2>
      ) : isLoading ? (
        <Button>
          <Box mx="small" inline>
            <InlineSpinnerIcon />
          </Box>
        </Button>
      ) : (
        <HTMLSelect
          // iconProps={{ icon: 'flag' }}
          onChange={(e) =>
            addTagMutation.mutate({
              taskId: task._raw.task_id,
              flag: e.target.value,
            })
          }
        >
          {flags.map((flag, index) => (
            <option value={flag} key={index}>
              {flag.split('-')[1]}
            </option>
          ))}
        </HTMLSelect>
      )}
    </>
  )
}

export default FlagTask
